module.exports = __webpack_public_path__ + "img/SnackMatch.da5bfdf5.png";